import {Identity} from '@/store/modules/User';
import jwtDecode from 'jwt-decode';

export function getIdentityFromJwt(token, refreshToken) {
    const jwt = jwtDecode(token);
    return new Identity(jwt.userId, token, refreshToken, jwt.exp, jwt.roles);
}

function getParams() {
    const paramsString = localStorage.getItem(this.$route.name);

    if (!paramsString) {
        return null;
    }

    return JSON.parse(paramsString);
}

export function getDatatableParams() {
    const params = getParams.call(this);

    if (!params) {
        return;
    }

    this.options.page = parseInt(params.page);
    this.options.itemsPerPage = parseInt(params.itemsPerPage);

    if (params.filters) {
        this.filters = params.filters;
    }
}

export function setDatatableOptions() {
    let params = getParams.call(this);

    params = {
        ...params,
        ...{
            page: this.options.page,
            itemsPerPage: this.options.itemsPerPage
        }
    };

    localStorage.setItem(this.$route.name, JSON.stringify(params));
}

export function setDatatableFilters() {
    let params = getParams.call(this);

    params = {
        ...params,
        filters: this.filters
    };

    localStorage.setItem(this.$route.name, JSON.stringify(params));
}